import type { TagProps } from './Tag.types';

const Tag: React.FC<TagProps> = ({ title, link }) => {
  if (link) {
    return (
      <a href={link} className="tag tag--linked">
        {title}
      </a>
    );
  }

  return <span className="tag tag--unlinked">{title}</span>;
};

export default Tag;
